import type { FC } from 'react';
import { EnergySavingsLeaf, Apartment } from '@mui/icons-material';
import type { SvgIconProps } from '@mui/material';

import type { AuditType } from '#packages/data-collection/models/audit';

export type AuditTypeIconProps = SvgIconProps & {
  /**
   * The type of the audit.
   */
  type: AuditType;
};

export const AuditTypeIcon: FC<AuditTypeIconProps> = ({ type, ...props }) => {
  switch (type) {
    case 'ea': {
      return <EnergySavingsLeaf {...props} />;
    }
    case 'bca': {
      return <Apartment {...props} />;
    }

    default: {
      throw new Error(`Unknown audit type: ${type}`);
    }
  }
};
